import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import ItemList from "./components/ItemList";
import NewsCard from "./components/NewsCard";
import ItemDetail from "./components/ItemDetail";
import AuctionDetail from "./pages/AuctionDetail";
import AboutCurrency from "./pages/AboutCurrency";
import CreateAuction from "./pages/CreateAuction";
import PrivateRoute from "./components/PrivateRoute";
import AdminDashboard from "./components/AdminDashboard";
import MyPendingAuctions from "./components/MyPendingAuctions";
import EditAuctionPage from "./pages/EditAuctionPage";
import AdminLiveAuctionsPage from "./pages/AdminLiveAuctions";
import Profile from "./pages/Profile";
import { ExchangePage } from "./pages/ExchangePage";
import Login from "./components/auth/Login";
import AdminUsersPage from "./pages/AdminUsersPage";
import StripeTest from "./components/StripeTest";
import Registro from "./components/auth/Registro";
import ForgotPassword from "./components/auth/ForgotPassword";
import ResetPassword from "./components/auth/ResetPassword";
import BlogList from "./components/BlogList";
import BlogDetail from "./components/BlogDetail";
import BlogEdit from "./components/BlogEdit";
import BlogCreate from "./components/BlogCreate";
import EditAuctionAdmin from "./pages/EditAuctionAdmin";
import PebSearch from "./components/PebSearch";
import CurrencyAdminForm from "./components/CurrencyAdminForm";
import AdminEscrowList from "./components/admin/AdminEscrowList";
import AdminBlogManager from "./components/admin/AdminBlogManager";
import PopupContentEditor from "./components/admin/PopupContentEditor";
import AdminLogsPage from "./pages/AdminLogsPage";
import GisManager from "./components/GisManager";
import GisDetail from "./components/GisDetail";
import WhatsAppMessaging from "./components/WhatsAppMessaging";
import WhatsAppMonitorDashboard from "./components/WhatsAppMonitorDashboard";
import WhatsAppVerification from "./components/WhatsAppVerification";
import VerificationForm from "./components/VerificationForm";

const AppRoutes: React.FC = () => {
  const { user } = useAuth();

  return (
    <Routes>
      <Route
        path="/"
        element={
          user ? (
            <ItemList />
          ) : (
            <>
              <NewsCard />
              <ItemList />
            </>
          )
        }
      />
      <Route path="/items/:id" element={<ItemDetail />} />
      <Route path="/auction/:id" element={<AuctionDetail />} />
      <Route path="/about-currency" element={<AboutCurrency />} />
      <Route path="/registro" element={<Registro />} />
      <Route path="/register" element={<Registro />} />
      <Route
        path="/blog"
        element={
          <PrivateRoute>
            <BlogList />
          </PrivateRoute>
        }
      />
      <Route
        path="/blog/:id"
        element={
          <PrivateRoute>
            <BlogDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <PrivateRoute adminOnly={true}>
            <AdminDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/edit-auction/:id"
        element={
          <PrivateRoute adminOnly={true}>
            <EditAuctionAdmin />
          </PrivateRoute>
        }
      />
      <Route
        path="/blog/:id/edit"
        element={
          <PrivateRoute>
            <BlogEdit />
          </PrivateRoute>
        }
      />

      <Route
        path="/create"
        element={
          <PrivateRoute>
            <CreateAuction />
          </PrivateRoute>
        }
      />
      <Route
        path="/exchange"
        element={
          <PrivateRoute>
            <ExchangePage />
          </PrivateRoute>
        }
      />
      <Route
        path="/my-pending-auctions"
        element={
          <PrivateRoute>
            <MyPendingAuctions />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin-dashboard"
        element={
          <PrivateRoute adminOnly={true}>
            <AdminDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <PrivateRoute>
            <AdminUsersPage />
          </PrivateRoute>
        }
      />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      {/* Only one registro route! */}
      <Route
        path="/edit-auction/:id"
        element={
          <PrivateRoute>
            <EditAuctionPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/live"
        element={
          <PrivateRoute>
            <AdminLiveAuctionsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        }
      />
      <Route
        path="/test-payment"
        element={
          <PrivateRoute>
            <StripeTest />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/peb-search"
        element={
          <PrivateRoute>
            <PebSearch />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/currencies"
        element={
          <PrivateRoute>
            <CurrencyAdminForm />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/escrows"
        element={
          <PrivateRoute>
            <AdminEscrowList />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/gis"
        element={
          <PrivateRoute>
            <GisManager />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/gis/:parcelId"
        element={
          <PrivateRoute>
            <GisDetail />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/blogs"
        element={
          <PrivateRoute adminOnly={true}>
            <AdminBlogManager />
          </PrivateRoute>
        }
      />
      <Route
        path="/blog/create"
        element={
          <PrivateRoute>
            <BlogCreate />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/popup-content"
        element={
          <PrivateRoute adminOnly={true}>
            <PopupContentEditor />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/logs"
        element={
          <PrivateRoute adminOnly={true}>
            <AdminLogsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/whatsapp"
        element={
          <PrivateRoute adminOnly={true}>
            <WhatsAppMessaging />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/whatsapp-monitor"
        element={
          <PrivateRoute adminOnly={true}>
            <WhatsAppMonitorDashboard />
          </PrivateRoute>
        }
      />
      <Route
        path="/whatsapp-verification"
        element={
          <PrivateRoute>
            <WhatsAppVerification />
          </PrivateRoute>
        }
      />
      <Route
        path="/verification"
        element={
          <PrivateRoute>
            <VerificationForm />
          </PrivateRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoutes;
